import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReset = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.12267 4.99997C9.12267 4.44768 9.57038 3.99997 10.1227 3.99997H12C16.9706 3.99997 21 8.02941 21 13C21 17.9705 16.9706 22 12 22C7.02944 22 3 17.9705 3 13C3 10.8746 3.73795 8.91891 4.97079 7.37898C5.31595 6.94785 5.94527 6.87815 6.37641 7.22331C6.80755 7.56848 6.87724 8.19779 6.53208 8.62893C5.57294 9.82697 5 11.3452 5 13C5 16.866 8.13401 20 12 20C15.866 20 19 16.866 19 13C19 9.13398 15.866 5.99997 12 5.99997H10.1227C9.57038 5.99997 9.12267 5.55225 9.12267 4.99997Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.7071 1.78264C13.0976 2.17316 13.0976 2.80633 12.7071 3.19685L10.8772 5.02679L12.7071 6.85673C13.0976 7.24725 13.0976 7.88042 12.7071 8.27094C12.3166 8.66147 11.6834 8.66147 11.2929 8.27094L8.75585 5.7339C8.36533 5.34338 8.36533 4.71021 8.75585 4.31969L11.2929 1.78264C11.6834 1.39212 12.3166 1.39211 12.7071 1.78264Z",
		fill: "currentColor"
	})]
});
export default SvgReset;
